import { Component, viewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AutoComplete } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-project-worker-autocomplete',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AutoComplete, FormlyModule],
  template: `
    <div class="field">
      <label [for]="field.key" class="block mb-2" *ngIf="to.label">
        {{ to.label }}
        <span *ngIf="to.required" class="text-red-500">*</span>
      </label>
      <p-autocomplete
        #autoCompleteObj
        [forceSelection]="true"
        [suggestions]="to.suggestions"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [field]="'displayLabel'"
        [dropdown]="false"
        [style]="{ width: '100%' }"
        (onSelect)="to.onSelect($event)"
        (completeMethod)="to.searchObject(to, $event, field)"
        placeholder="Keresés név alapján...">
        <ng-template let-worker pTemplate="item">
          <div class="flex flex-column p-1">
            <div class="font-bold">{{ worker.employeeName }}</div>
            <div class="text-sm text-600" *ngIf="worker.motherName">
              Anyja neve: {{ worker.motherName }}
            </div>
            <div class="text-xs text-500" *ngIf="worker.birthDate">
              Születési dátum: {{ worker.birthDate | date: 'yyyy.MM.dd' }}
            </div>
          </div>
        </ng-template>
      </p-autocomplete>
    </div>
  `,
})
export class FormlyProjectWorkerAutoCompleteComponent extends FieldType<FieldTypeConfig> {
  readonly autoComplete = viewChild<AutoComplete>('autoCompleteObj');
}
